<template>
  <v-toolbar
    class="toolbar rounded-toolbar mb-4"
    :class="{ extended: value, 'elevation-3': value }"
    color="#e06f18"
    dense
    flat
    height="auto"
    extension-height="auto"
  >
    <div class="toggle d-flex flex-fill align-center" @click="toggle">
      <v-icon class="mr-2" color="#ffffff">mdi-chevron-down</v-icon>
      <span class="mr-2">Filtros</span>
      <span class="font-size-9e font-weight-light">click para desplegar</span>
    </div>
    <template #extension v-if="value">
      <slot></slot>
    </template>
  </v-toolbar>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';

  @Component
  export default class CollapsableToolbar extends Vue {
    @Prop({ default: false }) value: boolean;

    async created() {}

    toggle() {
      this.$emit('input', !this.value);
    }
  }
</script>

<style lang="scss" scoped>
  .toolbar {
    .toggle {
      cursor: pointer;
      color: #ffffff;
    }

    ::v-deep .v-toolbar__content {
      height: 48px;
    }

    ::v-deep .v-toolbar__extension {
      background-color: #ffffff;
      padding: 10px;
    }

    &.extended {
    }
  }
</style>
